export const AppRoutes = {
  // Login
  login: "/login",
  logout: "/logout",
  recover: "/recover",
  recoverComplete: "/recover-complete",
  resetPassword: "/reset-password",
  resetPasswordComplete: "/reset-password-complete",
  register: "/register",
  adminAuthCallback: "/auth/callback",

  // Home
  home: "/",

  // Match
  duringContractList: "/match/during-contract",
  canceledContractList: "/match/canceled_contract",
  trialMatchList: "/match/trial",
  trialCancelledList: "/match/trial_cancelled",
  matchCreate: "/match/create",
  matchDetail: "/match/:id/detail",
  matchEdit: "/match/:id/edit",

  // information
  information: "/information",
  informationCreate: "/information/create",
  informationEdit: "/information/:id/edit",

  // Convert
  convert: "/convert",
  convertHistory: "/convert/history",
  convertDetail: "/convert/:id",

  // Master data
  masterData: "/master-data",
  masterDataDetail: "/master-data/:type",

  // Contact
  unresolvedContact: "/contact/unresolved",
  resolvedContact: "/contact/resolved",
  unresolvedContactDetail: "/contact/unresolved/:id",
  resolvedContactDetail: "/contact/resolved/:id",

  // Contact type
  contactType: "/contact-type",
  contactTypeCreate: "/contact-type/create",
  contactTypeEdit: "/contact-type/:id/edit",

  // System setting
  emailSetting: "/email-setting",
  maintenanceSetting: "/maintenance-setting",

  // page not found
  pageNotFound: "/page-not-found",
  serverErrorPage: "/server-error",

  // Chat
  chat: "/chat",
  chatDetail: "/chat/:id",
};

export const MatchRoutes = [
  AppRoutes.duringContractList,
  AppRoutes.trialMatchList,
  AppRoutes.canceledContractList,
  AppRoutes.trialCancelledList,
  AppRoutes.matchCreate,
  AppRoutes.matchDetail,
  AppRoutes.matchEdit,
];

export const InformationRoutes = [AppRoutes.information, AppRoutes.informationCreate, AppRoutes.informationEdit];

export const ConvertRoutes = [AppRoutes.convert, AppRoutes.convertHistory, AppRoutes.convertDetail];

export const MasterDataRoutes = [AppRoutes.masterData, AppRoutes.masterDataDetail];

export const ContactRoutes = [
  AppRoutes.unresolvedContact,
  AppRoutes.resolvedContact,
  AppRoutes.unresolvedContactDetail,
  AppRoutes.resolvedContactDetail,
  AppRoutes.contactType,
  AppRoutes.contactTypeCreate,
  AppRoutes.contactTypeEdit,
];

export const SystemSettingRoutes = [AppRoutes.emailSetting, AppRoutes.maintenanceSetting];

export const ChatRoutes = [AppRoutes.chat, AppRoutes.chatDetail];

export const AdminRoutes = [
  AppRoutes.home,
  MatchRoutes,
  InformationRoutes,
  ContactRoutes,
  SystemSettingRoutes,
  ChatRoutes,
  ConvertRoutes,
  MasterDataRoutes,
].flat();
